export const ConsumerPostSubmissionDeclinedViewStyles = {
  sadFaceIcon: 'self-center mb-4',
  header: 'justify-center flex items-center text-center col-span-6 text-blue500 font-semibold text-20px sm:grid sm:col-span-4 sm:text-black sm:text-42px sm:text-center',
  text: 'mx-8 self-center text-center text-blue700 text-24px'
}
